import { render, staticRenderFns } from "./bundles-container.vue?vue&type=template&id=7a4e1d9d&scoped=true&lang=pug"
import script from "./bundles-container.js?vue&type=script&lang=js&external"
export * from "./bundles-container.js?vue&type=script&lang=js&external"
import style0 from "./bundles-container.vue?vue&type=style&index=0&id=7a4e1d9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4e1d9d",
  null
  
)

export default component.exports